import type { ActionPlanTemplate } from "src/api/client-api/actionPlanTemplates/useActionPlanTemplates";

export const STATUS_ACTIONS = {
    draft: ["view", "edit", "duplicate", "publish", "archive", "delete"],
    published: ["view", "edit", "duplicate", "archive", "delete"],
    archived: ["view", "duplicate", "unarchive", "delete"],
} as const;

export type TemplateMenuAction = (typeof STATUS_ACTIONS)[keyof typeof STATUS_ACTIONS][number];

export const canUseTemplateAction = (
    action: TemplateMenuAction,
    permissions: Pick<ActionPlanTemplate, "canView" | "canModify" | "canDelete">,
    canCreate: boolean,
): boolean => {
    if (action === "view") return permissions.canView;
    if (action === "duplicate") return canCreate;
    if (action === "delete") return permissions.canDelete;

    return permissions.canModify;
};
